import { polymorphic } from '../../utils/index.js';
export const DialogButtonBar = polymorphic.div('iui-dialog-button-bar');
